import React from 'react';
import {
  FeatureStrip,
  FeatureStripItem,
  FeatureStripIcon,
} from './Feature.styles.jsx';
import {
  FaEye,
  FaClipboardList,
  FaExclamationTriangle,
  FaCheckCircle,
} from 'react-icons/fa';

const Feature = () => {
  return (
    <FeatureStrip>
      <FeatureStripItem>
        <FeatureStripIcon>
          <FaEye />
        </FeatureStripIcon>

        <div>
          <strong>Independent Review</strong>
          <span>Get a clearer view of your current safety practices.</span>
        </div>
      </FeatureStripItem>

      <FeatureStripItem>
        <FeatureStripIcon>
          <FaClipboardList />
        </FeatureStripIcon>

        <div>
          <strong>Program Review</strong>
          <span>Look at procedures, documentation, and safety systems.</span>
        </div>
      </FeatureStripItem>

      <FeatureStripItem>
        <FeatureStripIcon>
          <FaExclamationTriangle />
        </FeatureStripIcon>

        <div>
          <strong>Gap Identification</strong>
          <span>Find areas that may require additional attention.</span>
        </div>
      </FeatureStripItem>

      <FeatureStripItem>
        <FeatureStripIcon>
          <FaCheckCircle />
        </FeatureStripIcon>

        <div>
          <strong>Practical Guidance</strong>
          <span>Turn findings into clearer next steps.</span>
        </div>
      </FeatureStripItem>
    </FeatureStrip>
  );
};

export default Feature;
